/**
 * created by hezq on 2019-09-09
 *
 * description： 接口配置模块化管理
 *
 */

import common from 'api/common.js'
import trade from 'api/trade'
import agreement from 'api/agreement'
import invoice from 'api/invoice'
import category from 'api/category'
import supplier from 'api/supplier'
import message from 'api/message'
import sign from 'api/sign'
import dialog from 'api/dialog'
import approval from 'api/approval'

const api = {
	common: common,
	trade: trade,
	agreement: agreement,
	invoice: invoice,
	category: category,
	supplier: supplier,
	message: message,
	sign: sign,
	dialog: dialog,
	approval: approval
}

export default api



// WEBPACK FOOTER //
// ./src/api/index.js